import { forwardRef } from "react";

const Input = forwardRef(
  ({ label, error, helpText, className = "", ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-neutral-700 mb-1">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={`
            w-full px-3 py-2.5 rounded-lg border text-sm text-neutral-900
            transition-colors duration-150 outline-none
            placeholder:text-neutral-400
            ${
              error
                ? "border-error focus:ring-2 focus:ring-error/20"
                : "border-neutral-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20"
            }
            disabled:bg-neutral-50 disabled:text-neutral-400 disabled:cursor-not-allowed
            ${className}
          `}
          {...props}
        />
        {error && <p className="mt-1 text-xs text-error">{error}</p>}
        {helpText && !error && (
          <p className="mt-1 text-xs text-neutral-400">{helpText}</p>
        )}
      </div>
    );
  },
);

Input.displayName = "Input";

export default Input;
